import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import StandartButton from "components/atoms/StandartButton";
import ConfettiEffect from "components/ConfettiEffect";

import { wizardButtonSx } from "../../SignalWizard.styled";
import { Content, Logo, Root, Subtitle, Title } from "./SuccessStep.styled";

const SuccessStep = ({ language, trackerName, onFinish }) => (
    <Root>
        <ConfettiEffect />
        <Content>
            <Logo src="/assets/images/signal-sight.png" alt="SignalSight" />
            <div>
                <Title>
                    {language?.tracker_wizard?.congratulations ??
                        "Congratulations"}
                    ,
                </Title>
                <Subtitle>
                    <strong>{trackerName.trim()}</strong>{" "}
                    {language?.tracker_wizard?.has_been_created ??
                        "has been created."}
                </Subtitle>
            </div>
            <StandartButton
                variant="contained"
                color="primary"
                onClick={onFinish}
                endIcon={<ArrowForwardIcon />}
                sx={wizardButtonSx}
                data-cy="wizard-complete-continue"
            >
                {language?.tracker_wizard?.continue ?? "Continue"}
            </StandartButton>
        </Content>
    </Root>
);

export default SuccessStep;
